import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB1J: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="j) požadavky na kácení dřevin"
      subtitle=""
      sectionKey="b1j"
    >
      <>
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1j.hasTreeCuttingRequirements"
            label="Požadavky na kácení dřevin"
          />
        </div>
        {formik?.values.b1j?.hasTreeCuttingRequirements && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1j.treeCuttingRequirements"
              label=""
              component={RichTextInput}
              aiHint={
                'Požadavky na kácení dřevin v souvislosti s odstraňováním stavby'
              }
            />
          </div>
        )}
      </>
    </FormSectionTwoColumns>
  )
}
